export const $ = document.querySelector.bind(document);
export const $$ = document.querySelectorAll.bind(document);
export const isMobileXs = window.matchMedia('(max-width: 684px)');
export const isMobile = window.matchMedia('(max-width: 767px)');
export const isNotMobile = window.matchMedia('(min-width: 768px)');
export const isTablet = window.matchMedia('(max-width: 1023px)');
export const isDesktop = window.matchMedia('(max-width: 1247px)');
export const isDesktopLarge = window.matchMedia('(max-width: 1399px)');
export const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
import dataLayerPushSlider from '@utils/dataLayerPushSlider';
export const sliderConfig = {
  spaceBetween: 16,
  navigation: {
    prevEl: '[data-au-slider-prev]',
    nextEl: '[data-au-slider-next]',
  },
  scrollbar: {
    el: '[data-au-slider-scrollbar]',
  },
  slidesPerView: 'auto',
  freeMode: true,
  a11y: {
    enabled: true,
    slideRole: null,
  },
  on: {
    touchEnd(swiper, event) {
      dataLayerPushSlider(swiper, event);
    },
  },
};
